import { render, staticRenderFns } from "./notifText.vue?vue&type=template&id=6dc95367&scoped=true&"
import script from "./notifText.vue?vue&type=script&lang=js&"
export * from "./notifText.vue?vue&type=script&lang=js&"
import style0 from "./notifText.vue?vue&type=style&index=0&id=6dc95367&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc95367",
  null
  
)

export default component.exports